module.exports = __webpack_public_path__ + "img/pwa_food_top1.ef412b68.png";